import { RoutingMap } from '@app/entities';
import { NavigationHelper } from '@common';
import { Seo } from '@common/components';
import { AuthCard, MPSegmented } from '@components';
import { Layout } from 'antd';
import { useNavigate } from 'react-router-dom';
import Styles from './Styles.module.scss';
import { useCheckAuthToken } from './hooks/useCheckAccessToken';
import { useCurrentView } from './hooks/useCurrentView';
import { Login, Signup } from './views';

export default function Authentication() {
    useCheckAuthToken();
    const currentView = useCurrentView();
    const navigate = useNavigate();

    function handleAuthChange(value: string) {
        switch (value) {
            case 'login':
                navigate(RoutingMap.Login);
                break;
            case 'signup':
                navigate(RoutingMap.Signup);
                break;
            default:
                navigate(RoutingMap.Login);
                break;
        }
    }

    function onNavigateToHome() {
        NavigationHelper.Home().navigate();
    }

    const authCardMap = {
        login: <Login />,
        signup: <Signup />,
    };

    const seoTitle = currentView === 'signup' ? 'Sign Up - ModelPark' : 'Sign In - ModelPark';
    const seoDescription =
        currentView === 'signup'
            ? 'Create a free ModelPark account to share and demo your ML applications with secure URLs.'
            : 'Sign in to ModelPark to manage and share your ML applications.';

    return (
        <Layout className={Styles.LayoutContainer}>
            <Seo
                title={seoTitle}
                description={seoDescription}
                name="ModelPark"
                keywords="modelpark, login, signup, machine learning, AI deployment"
            />
            <img
                src="/auth-logo.svg"
                alt="logo"
                onClick={onNavigateToHome}
                className={Styles.Logo}
            />
            <AuthCard>
                <MPSegmented
                    value={currentView}
                    onChange={(value: any) => handleAuthChange(value)}
                    options={[
                        {
                            label: <div>Sign In</div>,
                            value: 'login',
                        },
                        {
                            label: <div>Sign Up</div>,
                            value: 'signup',
                        },
                    ]}
                />
                {authCardMap[currentView]}
            </AuthCard>
        </Layout>
    );
}
